import React from 'react'
import { PageTitle } from '../../layout/core'
import TicketDetailsPage from './ticketDetailsPage'

const TicketDetails = () => {
  return (
    <div>
      <PageTitle breadcrumbs={[]}>Ticket Details</PageTitle>
      <TicketDetailsPage />
    </div>
  )
}

export default TicketDetails
